export const DISCONNECT_STATUS_DELAY = 3 * 1000; // ms
export const THRASH_THRESHOLD = 5 * 1000; // ms
export const REFRESH_INTERVAL = 45 * 60 * 1000; // 45 minutes, in ms
export const OFFLINE_RECONNECT_TIMEOUT = 10 * 1000; // 10 seconds, in ms

// horizon
export const DEVICE_RESPONSE_TIMEOUT = 30 * 1000;
export const DEVICE_TIMEOUT_MESSAGE = 'Device request timed out';
export const CLIENT_INIT_FAILURE_MESSAGE = 'Failed to initialize IoT client';
